export const FINANCED_OFFERS_ON_FOLDER_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FinancedOffersOnFolderUpdated";
export const FOLDER_FINANCED_OFFERS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FolderFinancedOffersUpdated";
export const CLIENT_OFFERS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.ClientOffersInvalidated";
export const FINANCED_OFFERS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FinancedOffersInvalidated";
export const BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_EXECUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.BlockFacilitySublimitAmountManuallyExecuted"